import {Action} from '@ngrx/store';
import {type} from '../utilities/type';
import {Service} from '../models/service';

export const servicesActionTypes = {
  LOAD: type('[Services] Load'),
  LOAD_SUCCESS: type('[Services] Load Success'),
  LOAD_FAIL: type('[Services] Load Error'),
  CLEAR: type('[Services] Clear')
};

export class LoadServicesAction implements Action {
  readonly type = servicesActionTypes.LOAD;
  constructor() {}
}

export class LoadServicesSuccessAction implements Action {
  readonly type = servicesActionTypes.LOAD_SUCCESS;
  constructor(public payload?: Service[]) {}
}

export class LoadServicesFailAction implements Action {
  readonly type = servicesActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
export class ClearServicesAction implements Action {
  readonly type = servicesActionTypes.CLEAR;
  constructor() {}
}
